<!-- Container-fluid starts -->
<div class="container-fluid" #content id="modal-basic-title">
	<div class="row">
		<div class="col-sm-12">
			<div class="">
				<!-- Title and search bar -->
				<div class="">
					<h2 class="title-page">Fiches chantiers</h2>
					<div class="searchbar-btn d-flex justify-content-start align-items-center">
                        <div class="search-block">
                            <input type="text" [(ngModel)]="searchField" class="form-control"
                                placeholder='Recherche par chantier...' (keydown.enter)="onSearchChange(searchField)">
                            <div class="btn-reset-search" (click)="resetSearch()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-delete" _ngcontent-bnt-c218="">
                                    <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path>
                                    <line x1="18" y1="9" x2="12" y2="15"></line>
                                    <line x1="12" y1="9" x2="18" y2="15"></line>
                                </svg>
                            </div>
                        </div>
                        <div class="btn-submit">
                            <button type="button" class="btn btn-submit ng-star-inserted btn-success btn-submit-search"
                                (click)="onSearchChange(searchField)">Valider</button>
                        </div>
                    </div>						
				</div>

				<div class="">
					<!-- Table -->
					<ngx-datatable [rows]="dataTableFicheChantier" class="material striped" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [columns]="columns" [messages]="empty_msgFr">
						<!-- Table columns -->
						<ngx-datatable-column *ngFor="let column of columns; let i = index" name="{{ column.name }}" prop="{{ column.prop }}">
							<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
								<!-- BTN voir -->
								<span *ngIf="column.prop === 'btn_show'">
									<button class="btn_bo btn_show" (click)="showClientInfos(row)">
										<i class="fa fa-eye fa-lg"></i>
										Voir
									</button>
								</span>
								<span class="client-data">
									<span *ngIf="column.prop !== 'btn_show'" class="custome-tooltip">{{ value }}</span>
									{{ value }}
								</span>
							</ng-template>
						</ngx-datatable-column>
					</ngx-datatable>
				</div>
			</div>
			<!-- Pagination bar -->
			<div class="pagination-top">
				<ngb-pagination class="d-flex justify-content-center" [pageSize]="totalItems" [collectionSize]="collectionSize" [(page)]="currentPage" [maxSize]="5" [rotate]="true"
				[ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
			</div>
		</div>
	</div>
</div>
<!-- Container-fluid Ends -->
